<template>
  <section class="whyMontebit-section" id="por-que-montebit">
    <div class="whyMontebit-section__title-container">
      <h2>¿Por qué Montebit?</h2>
      <p>Creamos productos de manera ágil, implementando los mejores protocolos de seguridad para
        generar servicios innovadores que trabajan con la tecnología bitcoin.</p>
    </div>
       <div class="whyMontebit-section__cards-container">
        <CardFactors
        v-for="(item, index) in whyMontebitTexts"
        :key="index"
        :title="item.title"
        :description="item.subtitle"
        :src="item.imgPath"  
        />        
       </div>
  </section>
</template>
<script>
import {IntersectionObserverMixin} from "@/mixins/IntersectionObserverMixin"
import CardFactors from "@/components/atoms/CardFactors.vue";
import newTexts from "@/data/newTexts"

export default {  name: "WhyMontebit",
  components: {
    CardFactors,
  },
  mixins: [IntersectionObserverMixin("por-que-montebit")],
  data(){
    return {
      whyMontebitTexts: newTexts.whyMontebitSection
    }
  },
};
</script>
